import { types as userTypes } from 'src/store/user/user.types';
import { types as userInfoTypes } from 'src/store/user-info/user-info.types';
import { persistUserPreferencesFromState } from 'src/utils/user-preferences/user-preferences';

const PERSIST_ACTION_TYPES = new Set([
    userTypes.SET_USER_THEME,
    userTypes.SET_USER_AGENCY_ID,
    userTypes.SET_USER_SELECTED_LOCATION_INFO,
    userInfoTypes.SET_SELECTED_JURISDICTION,
]);

let isRestoringUserPreferences = false;

/**
 * Suppress preference writes while bootstrap is applying stored defaults.
 * Prevents list[0] fallbacks from overwriting valid saved preferences.
 * @param {Function} callback
 */
export const runWithUserPreferencesRestore = (callback) => {
    isRestoringUserPreferences = true;
    try {
        return callback();
    } finally {
        isRestoringUserPreferences = false;
    }
};

/**
 * Persist sidebar UI preferences to localStorage whenever they change.
 */
export const userPreferencesMiddleware = (store) => (next) => (action) => {
    const result = next(action);

    if (!isRestoringUserPreferences && PERSIST_ACTION_TYPES.has(action.type)) {
        persistUserPreferencesFromState(store.getState());
    }

    return result;
};
